import React, { useEffect, useState } from 'react'

import { Box, Paper, Typography, Container, Divider, Button, TextField, FormControl } from '@mui/material';

import CustomMessage from '../../utils/components/CustomMessage';

const ImageAfterUpdoad = ({ url }) => {
  const apiUrl = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PROD_IMAGES_PATH : process.env.REACT_APP_DEV_IMAGES_PATH;
  const imgUrl = `${apiUrl}/${url}`; // cambiar segun la empresa

  const [apiRes, setApiRes] = useState({ show: false, message: '', severity: '' });

  const handleCloseMessage = (show) => {
    setApiRes(state => { return { ...state, show: show } });
  }

  const handleButton = () => {
    navigator.clipboard.writeText(imgUrl);
    setApiRes(state => { return { ...state, show: true, message: 'Link copiado al portapapeles', severity: 'success' } });
  }

  return (
    <>
      <Container maxWidth='xl' style={{ marginTop: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Paper elevation={3} style={{ padding: '48px', display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center' }}>
          {url !== undefined ? (
            <>
              <Typography variant='body1' className='my-3' color='success.main'><i className='fad fa-check-circle fa-5x'></i></Typography>
              <Typography variant='h4' style={{ fontWeight: 700 }}>Carga Exitosa</Typography>
              <Divider variant="middle" className='my-3' />

              <img src={imgUrl} style={{ maxWidth: '400px', height: 'auto' }} alt={imgUrl} className='img' />
              <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline', margin: '12px 0px' }}>
                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                  <TextField type='url' name='copyImage' label="Link" variant="outlined" value={imgUrl} />
                </FormControl>
                <Button variant="contained" className='mx-2' size='large' onClick={() => handleButton()}>
                  copiar link
                </Button>
              </Box>
            </>
          ) : (
            <>
              <Typography variant='body1' className='my-3' color='error.main'><i className='fad fa-exclamation-triangle fa-5x'></i></Typography>
              <Typography variant='h4' style={{ fontWeight: 700 }}>Ocurrió un error al subir la imagen, intentalo de nuevo mas tarde!!!</Typography>
              <Divider variant="middle" className='my-3' />

              <Typography variant='body2' style={{ fontWeight: 700 }}>Actualiza la página para intentarlo de nuevo</Typography>
            </>
          )}
        </Paper>
      </Container>
      <CustomMessage open={apiRes.show} message={apiRes.message} severity={apiRes.severity} handleCloseMessage={handleCloseMessage} />
    </>
  )
}
export default ImageAfterUpdoad
